<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Registrar {{ absences_type == 'vacations' ? 'Vacaciones' : 'Faltas o Inasistencias' }}</h4>
                <button ref="closeAbsenceModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3">
                                <label>Empleado</label>
                                <select class="form-select" v-model="form.employee_id" v-bind:class="formSubmitted ? errors.employee_id ? 'is-invalid' : 'is-valid' : ''" disabled>
                                    <option v-for="(employee, index) in employees" :key="index" :value="employee.id">{{ employee.name }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.employee_id">{{ errors.employee_id }}</div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Tipo</label>
                                <select class="form-select" v-model="form.type" v-bind:class="formSubmitted ? errors.type ? 'is-invalid' : 'is-valid' : ''" disabled>
                                    <option v-for="(type, index) in types" :key="index" :value="type.code" v-show="absences_type == 'vacations' && type.code == 'vacation'">{{ type.name }}</option>
                                    <option v-for="(type, index) in types" :key="index" :value="type.code" v-show="absences_type != 'vacations' && type.code != 'vacation'">{{ type.name }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.type">{{ errors.type }}</div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Rango de Fechas</label>
                                <Datepicker class="datepicker-here form-control digits" style="height: 47px;" v-model="form.dates" :enable-time-picker="false" :locale="'es-MX'" :format-locale="es" format="dd/MM/yyyy" :multi="true" range></Datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="padding: 0px 10px;">
                            <div class="mb-3">
                                <label>Motivo</label>
                                <input class="form-control" type="text" v-model="form.observations" v-bind:class="formSubmitted ? errors.observations ? 'is-invalid' : 'is-valid' : ''" placeholder="">
                                <div class="invalid-feedback" v-if="errors.observations">{{ errors.observations }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="employee != null && employee.absences_list !== undefined && employee.absences_list.length > 0">
                    <div class="col-sm-12" style="padding: 0px 10px;">
                        <br /><br />
                        <span style="font-size: 18px; font-weight: bold;">{{ absences_type == 'vacations' ? 'VACACIONES' : 'FALTAS' }} DE LA QUINCENA</span>
                        <br />
                        <div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(absence, index) in employee.absences_list" :key="index">
                                        <td>{{ $formatDate(absence.date) }}</td>
                                        <td>{{ absence.type == "inability" ? "Incapacidad" : (absence.type == "incidence" ? "Incidencia" : (absence.type == "justified" ? "Falta Justificada" : (absence.type == "vacation" ? "Vacaciones" : "Falta o Inasistencia"))) }}</td>
                                        <td>
                                            <button class="btn btn-danger btn-sm" type="button" style="float: right;" @click="deleteAbsence(employee.id, absence.date)"><i class="icon-close"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="storeAbsenceValidation">Registrar {{ absences_type == "vacations" ? "Vacaciones" : "Falta o Inasistencia" }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import validations from "@/mixins/validations/absenceValidations";

export default {
    name: 'employee_absence_modal',
    mixins: [validations],
    props: {
        employees: Array,
    },
    components: {
        Datepicker
    },
    data(){
        return{
            showModal: true,
            types: [{code: 'absence', name: 'Falta'}, {code: 'inability', name: 'Incapacidad'}, {code: 'incidence', name: 'Incidencia'}, {code: 'vacation', name: 'Vacaciones'}, {code: 'justified', name: 'Falta Justificada'}],
            employee: null,
            absences_type: ''
        }
    },
    beforeMount: async function() {
        this.clearForm();
    },
    methods: {
        loadEmployee(employee, type){
            this.employee = type;

            this.employee = employee;

            this.form.employee_id = employee.id;
            this.absences_type = type;

            this.form.type = this.absences_type == 'vacations' ? 'vacation' : 'absence';
            this.form.observations = this.absences_type == 'vacations' ? 'Vacaciones con goze de sueldo y prima vacacional.' : 'Falta, Inasistencia o Incapacidad Médica';
        },
        async storeAbsence(form) {
            let response = await ws.storeAbsence(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("refresh", response.data );
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async deleteAbsence(employee_id, date) {
            let response = await ws.deleteAbsence(employee_id, date);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("refresh", response.data );
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeAbsenceModal.click();
        }
    }
}
</script>